import { connect } from 'react-redux';

import StatisticsDoubleLineChart from '@/components/StatisticsDoubleLineChart';
import {
  getLeftYValues,
  getMetrics,
  getRightYValues,
  getScale,
  getXValues,
} from '@/features/campaignsStatisticsPage/selectors';
import { getStatsIds } from '@/features/statisticsPage/selectors';

import TooltipContent from '../TooltipContent';

const mapStateToProps = state => ({
  xs: getXValues(state),
  leftYs: getLeftYValues(state),
  rightYs: getRightYValues(state),
  scale: getScale(state),
  selectedStatsIds: getStatsIds(state),
  TooltipContent,
  stats: getMetrics(state),
});

export default connect(mapStateToProps)(StatisticsDoubleLineChart);
